<template>
  <section class="w-full p-6">
    <h1 v-if="!trabalho" class="text-xl font-bold text-gray-900 mb-5">
      Para prosseguir com a avaliação, informe a mesa
    </h1>
    <h1 class="text-xl font-bold text-gray-900 mb-5" v-else>
      Agora, informe suas notas
    </h1>
    <div v-if="!trabalho">
      <label class="block text-sm font-medium text-gray-900">Mesa</label>
      <input type="text"
             v-model="mesa"
             name="email" class="border border-gray-300 text-gray-900 sm:text-sm rounded-lg block w-full p-2.5" placeholder="Número da mesa">
      <p v-if="mesaInvalida" class="mt-2 text-xs text-red-600">Você não pode avaliar este projeto.</p>
    </div>
    <button v-if="!trabalho" @click="buscaTrabalho" type="button" class="w-full mt-3 text-white bg-blue-500 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Buscar</button>

    <form v-if="trabalho" @submit.prevent>
      <div class="flex justify-between items-center mb-2">
        <span>Mesa: <b>{{trabalho.mesa}}</b></span>
        <button type="button" class="text-white bg-amber-500 font-medium rounded-lg text-sm px-5 py-2.5 text-center" @click="trocarMesa">Trocar mesa</button>
      </div>

      <div class="mt-2 mb-6">
        <p class="mb-2">Trabalho: <b v-text="trabalho.nome"></b></p>
<!--        <p class="mb-4">Orientador: <b v-text="trabalho.orientador.nome"></b></p>-->
        <p>Alunos:</p>
        <p class="mt-1 fs-1 pl-4" v-for="aluno in trabalho.alunos" v-text="aluno.nome"></p>
      </div>

      <div v-if="jaAvaliou" class="p-4 mb-4 text-sm text-yellow-700 bg-yellow-100 rounded-lg" role="alert">
        <span class="font-medium">Você já avaliou essa mesa!</span> Suas notas serão preenchidas abaixo e você pode alterá-las.
      </div>
      <div class="mb-3">
        <label class="block text-sm font-medium text-gray-900 mb-2">Pôster (de 0 a 10)</label>
        <input type="number"
               pattern="\d*"
               v-model.number="form.notas.poster"
               @change="verificaNota(0, 10, 'poster')"
               class="border border-gray-300 text-gray-900 sm:text-sm rounded-lg block w-full p-2.5">
        <p v-if="erros.poster" class="mt-2 text-xs text-red-600">Nota inválida, informe de 0 a 10</p>
      </div>
      <div class="mb-3">
        <label class="block text-sm font-medium text-gray-900 mb-2">Exposição do Trabalho (de 0 a 25)</label>
        <input type="number"
               pattern="\d*"
               v-model.number="form.notas.exposicao"
               @change="verificaNota(0, 25, 'exposicao')"
               class="border border-gray-300 text-gray-900 sm:text-sm rounded-lg block w-full p-2.5">
        <p v-if="erros.exposicao" class="mt-2 text-xs text-red-600">Nota inválida, informe de 0 a 25</p>

      </div>
      <div class="mb-3">
        <label class="block text-sm font-medium text-gray-900 mb-2" v-if="trabalho.Categoria_ID === 4">Geração de Produto ou Processo Tecnológico (de 0 a 30)</label>
        <label class="block text-sm font-medium text-gray-900 mb-2" v-else>A Investigação (de 0 a 30)</label>
        <input type="number"
               pattern="\d*"
               v-model.number="form.notas.terceira"
               @change="verificaNota(0, 30, 'terceira')"
               class="border border-gray-300 text-gray-900 sm:text-sm rounded-lg block w-full p-2.5">
        <p v-if="erros.terceira" class="mt-2 text-xs text-red-600">Nota inválida, informe de 0 a 30</p>
      </div>
      <button type="button"
              @click="avalia"
              :disabled="hasErros || !complete"
              class="disabled:bg-gray-300 w-full text-white bg-blue-500 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Avaliar</button>
    </form>
  </section>
</template>

<script>
import {useForm} from "@inertiajs/inertia-vue3";
import { ref } from "vue"
import axios from "axios";

export default {
  name: "AvaliarMesa",
  data: () => {
    return {
      erros: {
        poster: false,
        exposicao: false,
        terceira: false
      },
      hasErros: true,
      complete: false,
      trabalho: null,
      mesa: null,
      mesaInvalida: false,
      jaAvaliou: false,
    }
  },
  setup() {
    const form = useForm({
      id: null,
      notas: {
        poster: null,
        exposicao: null,
        terceira: null
      },
    })

    return {
      form
    }
  },
  methods: {
    buscaTrabalho() {
      axios.get(route('mobile.busca-trabalho', this.mesa)).then( response => {
        if (response.status === 201) {
          this.mesaInvalida = true

          setTimeout(() => {
            this.mesaInvalida = false
          }, 8000)
        } else if (response.status === 202) {
          this.jaAvaliou = true

          setTimeout(() => {
            this.jaAvaliou = false
          }, 8000)
        } else {
          this.trabalho = response.data

          let jaAvaliou = this.trabalho.avaliadores_mesas.find(item => item.Avaliador_ID === this.$page.props.user.id)?.notas

          if (jaAvaliou) {
            this.jaAvaliou = true

            this.form.notas.poster = jaAvaliou.poster
            this.form.notas.exposicao = jaAvaliou.exposicao
            this.form.notas.terceira = jaAvaliou.terceira
          }

          this.form['id'] = this.trabalho.id
        }
      })
    },
    verificaNota(min, max, nota) {
      let nt = parseInt(this.form.notas[nota])
      this.erros[nota] = nt < min || nt > max;

      this.hasErros = Object.values(this.erros).filter(item => !!item).length > 0
      this.complete = Object.values(this.form.notas).filter(item => !item).length === 0
    },
    trocarMesa() {
      this.trabalho = null
      this.mesa = null
      this.jaAvaliou = false
      this.form.reset()
    },
    avalia() {
      this.form.post(route('mobile.avaliador.avaliar-mesa-store'), {
        onSuccess: () => {
          this.trocarMesa()
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
